import {
  ArrayInput,
  ReferenceInput,
  required,
  SelectInput,
  SimpleFormIterator,
  useNotify,
  useRefresh,
} from "react-admin";
import CheckIcon from "@mui/icons-material/Check";
import { Grid, Button } from "@mui/material";

import { settings } from "app";
import { erasmusRequests } from "api/erasmusApi";
import { studentRequests } from "api/studentApi";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import { toDateOnly } from "utils/helpers";
import { DisciplineIteratorItem } from "./DisciplineFields";

const toDisciplinesPayload = (disciplines = []) =>
  disciplines.map(discipline => ({
    disciplineId: discipline?.disciplineId,
    semester: discipline?.semester,
    studyGroup: discipline?.studyGroup,
  }));

const CheckArriveModal = ({ id, isBip = false, academicYearId = null, curriculumId, label = "Пристигнал" }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const defaultValues = {
    arrivalDate: toDateOnly(new Date().toISOString()),
    academicYearId,
    disciplines: isBip ? [] : [{}],
  };

  const handleArrive = async data => {
    const { data: response } = await dataProvider.customRequest(
      erasmusRequests.arriveIncomingStudentsRegular(id),
      {
        arrivalDate: data.arrivalDate,
        academicYearId: data.academicYearId,
        // a BIP student has no disciplines - the backend ignores them
        disciplines: isBip ? null : toDisciplinesPayload(data.disciplines),
      },
      "POST",
    );

    notify("Студентът е отбелязан като пристигнал", { type: "success" });

    // the conflicts do not block the arrival - the coordinator only needs to know about them
    const warnings = response?.scheduleConflictWarnings ?? [];

    if (warnings.length) notify(warnings.join("\n"), { type: "warning", multiLine: true, autoHideDuration: 10000 });

    refresh();
  };

  return (
    <FormModal
      titleContent="Записване за Еразъм"
      dialogSize="md"
      defaultValues={defaultValues}
      onConfirm={handleArrive}
      triggerButton={
        <Button
          variant="contained"
          color="success"
          startIcon={<CheckIcon />}
        >
          {label}
        </Button>
      }
    >
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={6}
        >
          <CustomDateInput
            source="arrivalDate"
            label="Дата на пристигане"
            noTime
            required={true}
            validate={required()}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <ReferenceInput
            source="academicYearId"
            reference={studentRequests.getAcademicYearsSelect()}
          >
            <SelectInput
              label="Учебна година"
              optionText="name"
              fullWidth
              validate={required()}
            />
          </ReferenceInput>
        </Grid>
        {isBip ? null : (
          <Grid
            item
            xs={12}
          >
            <ArrayInput
              source="disciplines"
              label="Дисциплини"
              fullWidth
              validate={required("Моля добавете поне една дисциплина!")}
            >
              <SimpleFormIterator
                inline={false}
                disableReordering
                sx={settings.style.iteratorWithoutGap}
              >
                <DisciplineIteratorItem curriculumId={curriculumId} />
              </SimpleFormIterator>
            </ArrayInput>
          </Grid>
        )}
      </Grid>
    </FormModal>
  );
};

export default CheckArriveModal;
